<template>
    <div class="container" v-if="isShow">
      <div class="content">
        <div class="content-left">
          <a class="background-image" v-if="replenish.article_href != ''" :href="replenish.article_href">
            <img class="img-pc" :src="replenish.pc_pic" alt="Background" />
            <img class="img-phone" :src="replenish.mobile_pic" alt="Background" >
          </a>
          <div class="background-image" v-else>
            <img class="img-pc" :src="replenish.pc_pic" alt="Background" />
            <img class="img-phone" :src="replenish.mobile_pic" alt="Background" >
          </div>
        </div>
        <div class="content-right">
          <h1 class="title">{{replenish.pic_title}}</h1>
          <p class="description">{{replenish.pic_content}}</p>
          <a class="action-button" :href="replenish.article_href">免费体验</a>
        </div>
      </div>
      <div class="content-phone">
        <h1 class="title">{{replenish.pic_title}}</h1>
        <p class="description">{{replenish.pic_content}}</p>
        <a class="action-button" :href="replenish.article_href">免费体验</a>
      </div>
    </div>
  </template>
  
  <script>
    import { useRouter } from 'vue-router';
    import { homeApi } from '@/api/home';
    
    export default {
      data(){
        return {
          isShow:false,
          replenish:[]
        }
      },
      
      methods:{
        freeTrial(){
          const router = useRouter();
          router.push('/toRegister');
        },
        freeclick(url){
          if(url !=''){
            window.location.href = url;
          }else{
           console.log('url is null');
          }

        },
        async getReplenish() {
          const response = await homeApi.getReplenish();
          this.replenish = response.data.info;
          this.isShow = response.data.replenish_whole_block_show === '1'
        }, 
      },
      mounted() {
        this.getReplenish();
      },
  }
    </script>
  
  <style scoped>
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 480px;
    background-color: #000;
    gap: 40px;
  }
  .background-image{
    height: 480px;
    overflow: hidden;
    display: block;
  }
  .background-image img {
    width: auto;
    height: 100%;
    display: block;
  }
  
  .content {
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    text-align: left;
    padding: 20px;
    border-radius: 8px;
    color: #fff;
    align-items: center;
  }
  
  .content-left {
    flex: 1;
  }
  
  .content-right {
    flex: 1;
    margin-left: 50px;
  }
  
  .title {
    font-size: clamp(2rem, 3vw, 4rem);
    color: #007bff;;
  }
  
  .description {
    /* font-size: clamp(1rem, 2vw, 1.5rem); */
    font-size: clamp(1.5rem, 2vw, 2rem);
    margin-bottom: 20px;
  }
  
  .action-button {
    height: 40px;
    line-height: 40px;
    width: 150px;
    background-color: #fff;
    color: #000;
    border: none;
    border-radius: 40px; /* 50% 圆角 */
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease; /* 添加过渡效果 */
    padding: 0;
    margin: 0;
    font-size: 15px;
    display: block;
    text-align: center;
  }
  
  .action-button:hover {
    background-color: #007bff;
    color: #fff;
  }
  .background-image .img-phone{display: none;}
  .background-image .img-pc{display: block;}
  .content-phone{
    display: none;
  }
  /* 移动端样式 */
  @media screen and (max-width: 768px) {
    .container {
      display: block;
      background-color: transparent;
      height: auto;
    }
    .content-phone{
    display: block;
  }
  .background-image{
    height: auto;
    aspect-ratio: 125/159;
  }
    .background-image img {
      max-width: 100%;
    }
    .content-left{
        display: none;
    }
    .content {
      display: block;
      position: static;
      width: 100%;
      padding: 0;
      background-color: black; /* 移动端不需要背景色 */
    }
    .content-left{
      display: block;
      overflow: hidden;
    }
    .content-right{
      display: none;
       margin-left: 0;
    }
    .content-phone{
      margin: 15px 20px 0;
      padding-bottom: 30px;
      border-bottom: 1px solid #e4e4e4;
    }
    .title {
        /* font-size: clamp(1.3rem, 2vw, 1.5rem); */
      font-size: 20px;
      color: #000;
      margin-bottom: 0;
    }
    .description {
       /* font-size: clamp(1rem, 2vw, 1.5rem); */
       font-size: 14px;
       color: #6e6e73;
       margin-bottom: 0;
    }
    .action-button {
        border: 2px solid #000; /* 添加黑色边框 */
        margin: 0 auto;
        margin-top: 10px;
        display: block;
        padding: 0;
        display: none;
    }
    .background-image .img-phone{display: block;}
    .background-image .img-pc{display: none;}  
  }
  </style>